import { Box, useMediaQuery, useTheme } from "@mui/material";
import HowItWorksBanking from "../Bank/HowItWorksBanking";

export default function HowItWorksEcomm() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box>
      {!isMobile && (
        <div 
          style={{
            width: '100%',
            height: '400px',
            background: '#E5FDFA',
            borderTopLeftRadius: '100% 200%',
            borderTopRightRadius: '100% 200%',
            position: 'absolute',
            bottom: 0,
            left: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }} 
        >
         <HowItWorksBanking />
        </div>
      )}
    </Box>
  );
}
